import { SignatureDocument } from 'azshared';
import React, { Fragment, useCallback, useState } from 'react';
import { SignatureAreaRtoChecks } from './signature-area-rto-checks';
import { SignatureAreaRtoDisclaimer } from './signature-area-rto-disclaimer';
import './signature-area-rto-document-content.scss';

export interface SignatureAreaRtoDocumentContentProps {
  isLoadingRejectProposal: boolean;
	isLoadingGetUrlForSignature: boolean;
  document: SignatureDocument; 
  clickGoForward: (documentId: string) => void; 
  clickRejected: (documentId: string) => void;
  fetchOrdineRto?: (bundleId: string, practiceNumber: string) => Promise<any>;
}

export const SignatureAreaRtoDocumentContent = (props: SignatureAreaRtoDocumentContentProps) => {
  const { document, clickGoForward, clickRejected, isLoadingRejectProposal, isLoadingGetUrlForSignature, fetchOrdineRto } = props;
  const [showFirstStep, setShowFirstStep] = useState(true);
  const [isLoadingRto, setIsLoadingRto] = useState(false);

  const handelGoNextPage = useCallback(async () => {
    if (fetchOrdineRto && (document.practiceNumber || document.id)) {
      try {
        setIsLoadingRto(true);
        await fetchOrdineRto(document.id, document.practiceNumber || document.id);
        setShowFirstStep(false);
      } catch (e) {
        console.error('Error fetching RTO details on forward click', e);
        setShowFirstStep(false);
      } finally {
        setIsLoadingRto(false);
      }
    } else {
      setShowFirstStep(false);
    }
  }, [fetchOrdineRto, document, setShowFirstStep]);

  const handelGoBackPage = useCallback(() => {
    setShowFirstStep(true);
  }, [setShowFirstStep]);

  return (
    <Fragment>
      {showFirstStep ? (
        <SignatureAreaRtoDisclaimer
          document={document}
          clickGoForward={handelGoNextPage}
          isLoading={isLoadingRto}
        />
      ) : (
        <SignatureAreaRtoChecks
          document={document}
          clickGoForward={clickGoForward}
          clickGoBack={handelGoBackPage}
          clickRejected={clickRejected}
          isLoadingRejectProposal={isLoadingRejectProposal}
          isLoadingGetUrlForSignature={isLoadingGetUrlForSignature} 
        />
      )}
    </Fragment>
  );
};
